const MarketCapitalBreakdownTable = require('okCharts/MarketCapitalBreakdownTable');

module.exports = MarketCapitalBreakdownTable;
